import MobileFeatureModal from './MobileFeatureModal';

export default MobileFeatureModal;
